export enum userInfo {
    birthPlaceCountry,
}
